import * as React from 'react'
import { Text, Block } from '$views/components'
import { DatepickerField } from '$views/RecommendationsForms/ResidenceForm/DateStep/components/DatepickerField'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { ButtonForm } from '$views/RecommendationsForms/ResidenceForm/components/ButtonForm'
import { draft } from '$utils/services/formDraftService'
import { validateAllDays } from '$views/RecommendationsForms/ResidenceForm/DateStep/DateStep.validator'

interface Props {
  onNextStep: () => void
  onPreviousStep: () => void
}

export const DateStep: React.FC<Props> = ({ onNextStep, onPreviousStep }) => {
  const [activeValidator, setActiveValidator] = React.useState<boolean>(false)

  const onSubmit = () => {
    const draftValues = draft.get(residenceFormDraftName)
    setActiveValidator(true)
    if (
      draftValues &&
      draftValues[ResidenceFormSteps.dateStep] &&
      validateAllDays(draftValues[ResidenceFormSteps.dateStep])
    ) {
      onNextStep()
    }
  }

  return (
    <>
      <Text title>2. Cuándo</Text>
      <Text marginTop="base" marginBottom="small">
        Indica los días en los que necesitas ayuda y la duración estimada
      </Text>
      <Block marginTop="small">
        <DatepickerField
          draftName={residenceFormDraftName}
          draftPropertyName={ResidenceFormSteps.dateStep}
          activeValidator={activeValidator}
        />
        <Block marginTop="small" marginBottom="large">
          <ButtonForm nextButtonLabel="Siguiente" onNextStep={onSubmit} onPreviousStep={onPreviousStep} />
          <Text marginTop="mini" color="menu" textAlign="center">
            Paso 2/4
          </Text>
        </Block>
      </Block>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/DateStep/DateStep.tsx